export interface GenericAPIResponse {
    status?: "success" | "unautorhized",
    error?: string,
}

export async function apiCall<T>(url, payload): Promise<T> {
    return new Promise((resolve, reject) => {
        $.ajax({
            type: "POST",
            url,
            data: JSON.stringify(payload),
            contentType: "application/json; charset=utf-8",
            dataType: "json",
            success: function (response) {
               // Node.js APIs return data directly, not in a .d property like ASP.NET Web Methods
               resolve(response);
            },
            error: function (error) {
                reject(new Error(error.statusText));
            }
        });
    });
}

let errorCount = 0;
const MAX_ERROR_COUNT = 3;
export function logError(e: Error): Promise<GenericAPIResponse> {
    if (errorCount >= MAX_ERROR_COUNT) {
        return Promise.resolve({ status: 'success' });
    }
    errorCount++;
    return apiCall<GenericAPIResponse>('/api/LogError',{
        message: e.message,
        stackTrace: e.stack
    })
}